/*
 * @Author: yaodongyi
 * @Date: 2024-03-22 19:54:10
 * @LastEditors: yaodongyi
 * @LastEditTime: 2025-05-14 17:58:34
 * @Description: 
 */
import React from 'react'
import {prodConfig} from "../config";

class NewIndexPage extends React.Component {
    constructor() {
        window.location.replace(`${prodConfig.MAIN_URL}/indexpage?from=outside_site&r=${Math.random()}`)
        super()
    }
    render() {
        return (
            <div style={{display: 'none'}}>loading</div>
        )
    }
}

export default NewIndexPage


// WEBPACK FOOTER //
// ./src/pages/NewIndexPage.js